import React, { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog';
import { CCol, CFormLabel, CRow } from '@coreui/react';
import { useReport } from '../contexts/ReportContext';
import { useCompanySetting } from '../contexts/CompanySettingContext';

function ViewSingleUserReport({ userId, setUserId, startDate, endDate }) {
    const { singleUserReport } = useReport();
    const { currency } = useCompanySetting();

    const [userReportDetail, setUserReportDetail] = useState(null);

    console.log("userId, startDate, endDate", userId, startDate, endDate);

    const fetchSingleUserReport = async () => {
        try {
            const report = await singleUserReport(startDate, endDate, userId);
            if (report.error === false) {
                setUserReportDetail(report.data);
            }
        } catch (error) {
            console.error('Error fetching single user report', error);
        }
    };

    useEffect(() => {
        if (userId && startDate && endDate) fetchSingleUserReport();
    }, [userId, startDate, endDate]);

    const handleClose = () => {
        setUserId(null);
    };

    return (
        <Dialog
            draggable={false}
            header={`User Detail`}
            visible={!!userId}
            style={{ width: '34vw' }}
            onHide={handleClose}
        >
            <div className='pt-3'>
                {userReportDetail && (
                    <div>
                        <CRow className='mb-3'>
                            <CCol lg={6} className='text-end'>
                                Name:
                            </CCol>
                            <CCol lg={6}>
                                <CFormLabel className='w-50'>{userReportDetail.userName}</CFormLabel>
                            </CCol>
                        </CRow>
                        <CRow className='mb-3'>
                            <CCol lg={6} className='text-end'>
                                Receipts From:
                            </CCol>
                            <CCol lg={6}>
                                <CFormLabel className='w-50'>{userReportDetail.from}</CFormLabel>
                            </CCol>
                        </CRow>
                        <CRow className='mb-3'>
                            <CCol lg={6} className='text-end'>
                                Receipts To:
                            </CCol>
                            <CCol lg={6}>
                                <CFormLabel className='w-50'>{userReportDetail.to}</CFormLabel>
                            </CCol>
                        </CRow>
                        <CRow className='mb-3'>
                            <CCol lg={6} className='text-end'>
                                First Action:
                            </CCol>
                            <CCol lg={6}>
                                <CFormLabel className='w-50'>{userReportDetail.firstCreatedAt ? userReportDetail.firstCreatedAt : '-'}</CFormLabel>
                            </CCol>
                        </CRow>
                        <CRow className='mb-3'>
                            <CCol lg={6} className='text-end'>
                                Last Action:
                            </CCol>
                            <CCol lg={6}>
                                <CFormLabel className='w-50'>{userReportDetail.lastCreatedAt ? userReportDetail.lastCreatedAt : '-'}</CFormLabel>
                            </CCol>
                        </CRow>
                        <CRow className='mb-3'>
                            <CCol lg={6} className='text-end'>
                                #Receipts Created:
                            </CCol>
                            <CCol lg={6}>
                                <CFormLabel className='w-50'>{userReportDetail.receiptsCreated}</CFormLabel>
                            </CCol>
                        </CRow>
                        <CRow className='mb-3'>
                            <CCol lg={6} className='text-end'>
                                #Payments:
                            </CCol>
                            <CCol lg={6}>
                                <CFormLabel className='w-50'>{userReportDetail.paymentCreated}</CFormLabel>
                            </CCol>
                        </CRow>
                        <CRow className='mb-3'>
                            <CCol lg={6} className='text-end'>
                                Revenue Created:
                            </CCol>
                            <CCol lg={6}>
                                <CFormLabel className='w-50'>{currency}{userReportDetail.createdRevenue}</CFormLabel>
                            </CCol>
                        </CRow>
                        <CRow className='mb-3'>
                            <CCol lg={6} className='text-end'>
                                Revenue Received:
                            </CCol>
                            <CCol lg={6}>
                                <CFormLabel className='w-50'>{currency}{userReportDetail.paymentRevenue}</CFormLabel>
                            </CCol>
                        </CRow>
                        {
                            userReportDetail.paymentMethodRevenue.length > 0 &&
                            userReportDetail.paymentMethodRevenue.map((paymentDetail) => (
                                <CRow className='mb-3'>
                                    <CCol lg={6} className='text-end'>
                                        {paymentDetail.paymentMethod}:
                                    </CCol>
                                    <CCol lg={6}>
                                        <CFormLabel className='w-50'>{currency}{paymentDetail.paymentRevenue}</CFormLabel>
                                    </CCol>
                                </CRow>
                            ))
                        }
                    </div>
                )}
            </div>
        </Dialog>
    )
}

export default ViewSingleUserReport